import { useQuery } from "@tanstack/react-query";
import { workQueueService } from "@/core/api/services";
import { workbenchKeys } from "@/core/api/queryKeys";

export function useQueueStats() {
  const query = useQuery({
    queryKey: workbenchKeys.stats.all,
    queryFn: async () => {
      const response = await workQueueService.getQueueStats({});
      return response.stats ?? null;
    },
    staleTime: 15 * 1000,
    refetchInterval: 30 * 1000,
  });

  const stats = query.data;

  return {
    total: stats?.total ?? 0,
    byStatus: stats?.byStatus ?? {},
    byType: stats?.byType ?? {},
    overdue: stats?.overdue ?? 0,
    unassigned: stats?.unassigned ?? 0,
    loading: query.isLoading,
    error: query.error?.message ?? null,
    refetch: query.refetch,
  };
}
